import { request } from '@umijs/max';
import { useEffect } from 'react';

// The API rejects revoked tokens immediately. Polling also removes idle pages
// within 2 minutes; tab focus/visibility changes check without waiting.
export default function LoginSessionMonitor() {
  useEffect(() => {
    let active = true;
    let pending = false;
    const check = async () => {
      if (!active || pending || document.hidden || !localStorage.getItem('token')) return;
      pending = true;
      try {
        await request('/api/v1/auth/session', { skipErrorHandler: true });
      } catch {
        // The global response interceptor handles revoked sessions. Temporary
        // network/database failures leave a valid login alone.
      } finally { pending = false; }
    };
    void check();
    const timer = window.setInterval(check, 120000);
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);
  return null;
}
